import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProviderCountry } from "@/redux/baseQuery";

export const configVehicleApi = createApi({
  baseQuery: baseQueryWithProviderCountry("vehicle"),
  reducerPath: "configVehicleApi",
  endpoints: () => ({}),
});
